import { Component } from '@angular/core';
import { DeviceService } from '../../services/device.service';

@Component({
  selector: 'app-help-and-support',
  standalone: true,
  imports: [],
  templateUrl: './help-and-support.component.html',
  styleUrl: './help-and-support.component.css',
})
export class HelpAndSupportComponent {
  constructor(private readonly deviceService: DeviceService) {}

  contactDetails: any = {};

  ngOnInit(): void {
    this.getContactUsDetails();
  }

  getContactUsDetails() {
    this.deviceService.getContactDetails().subscribe(
      (response: any) => {
        response.data.contactDetails.forEach((detail: any) => {
          this.contactDetails[detail.key] = detail.value;
        });
      },
      (err: any) => {
        console.log(err.error);
      }
    );
  }
}
